// Centralized error logging — console-based today, structured so a future
// remote error-tracking integration (Sentry, etc.) is a one-line swap
// inside this function rather than a change at every call site.
export function logError(context, error, extra) {
  // eslint-disable-next-line no-console
  console.error(`[${context}]`, error, extra || "");
}
